<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import { useModalContext } from '@gat-ship/vue-components'

  const modalContext = useModalContext()

  const props = defineProps<{
    title: string
    optional?: boolean
    class?: HTMLAttributes['class']
    show?: boolean
  }>()
</script>
<template>
  <div
    v-if="modalContext.modalType !== 'none' || props.show"
    role="separator"
    :class="
      cn(
        'relative flex w-full select-none items-center gap-1 border-x border-slate-200 bg-gray-100 px-5 py-1.5 text-xs text-gray-400 dark:border-slate-700 dark:bg-slate-900',
        props.class
      )
    "
    :style="{ letterSpacing: '0.05em' }"
  >
    <span class="font-medium uppercase">
      {{ title }}
    </span>
    <span v-if="optional">(optional)</span>
    <slot name="actions" />
  </div>
</template>
